export const parseStringForSpotifyId = (string) => {
  const pattern = /(track|album|playlist|artist)[:/]([a-zA-Z0-9]{22})(:?\?|$)/g;
  const matches = pattern.exec(string);
  if (matches && matches[1] && matches[2]) {
    const result = { type: matches[1], id: matches[2] };
    return result;
  } else return null;
};

export const spotifyResourceTypes = {
  TRACK: "track",
  ALBUM: "album",
  ARTIST: "artist",
  PLAYLIST: "playlist",
};
